/* Owner asked for the collection short description to only show its
   first few lines by default, fading into a "Read more" toggle to
   expand it (and collapse back again). The toggle button is rendered
   in Liquid already hidden (js-hidden, this theme's own stock "hide
   until JS decides otherwise" convention) - only revealed here, and
   only the collapsed/clamped state applied at all, if the content
   actually overflows the collapsed height. A short description that
   already fits within a few lines never gets clamped or shows a
   pointless toggle. */
(function () {
  const wrap = document.getElementById('llm-collection-shortdescription-wrap');
  const content = document.getElementById('llm-collection-shortdescription');
  const toggle = document.getElementById('llm-collection-shortdescription-toggle');
  if (!wrap || !content || !toggle) return;

  const label = toggle.querySelector('.llm-collection-shortdescription-toggle__label');
  const READ_MORE = 'Read more';
  const READ_LESS = 'Read less';

  // Measure BEFORE clamping (is-collapsed sets max-height via CSS) -
  // scrollHeight vs the natural, unclamped clientHeight is what tells
  // us whether clamping would actually hide anything.
  const naturalHeight = content.scrollHeight;
  wrap.classList.add('is-collapsed');
  const collapsedHeight = content.clientHeight;

  if (naturalHeight <= collapsedHeight + 1) {
    wrap.classList.remove('is-collapsed');
    return;
  }

  toggle.classList.remove('js-hidden');

  toggle.addEventListener('click', () => {
    const isCollapsed = wrap.classList.toggle('is-collapsed');
    toggle.setAttribute('aria-expanded', String(!isCollapsed));
    label.textContent = isCollapsed ? READ_MORE : READ_LESS;
  });
})();
